import store from '../store'
import { isPermissionActive, mergeSubscribersGrowthRoleDefaults } from './mergeSubscribersGrowthRoleDefaults'

function resolveProjectRoleId(project: { myRole?: string; users?: { id: string; role?: { id: string } }[] }) {
    if (project.myRole) {
        return project.myRole
    }
    const sub = store.getters.myUser?.sub as string | undefined
    if (!sub || !Array.isArray(project.users)) {
        return undefined
    }
    return project.users.find((user) => user.id === sub)?.role?.id
}

export function checkRole(projectId: string, permissionId: string) {
    return checkRoleWithOptions(projectId, permissionId)
}

type CheckRoleOptions = {
    ignoreIsActive?: boolean
}

export function checkRoleWithOptions(
    projectId: string,
    permissionId: string,
    options: CheckRoleOptions = {}
) {
    const project = store.getters.projectById(projectId)

    if (!project) {
        return false
    }
    const rolesSettings = project.rolesSettings
    if (!rolesSettings) {
        return false
    }
    let permissionRolesSettings = rolesSettings[permissionId]
    if (!permissionRolesSettings) {
        mergeSubscribersGrowthRoleDefaults(project)
        permissionRolesSettings = rolesSettings[permissionId]
    }
    if (!permissionRolesSettings) {
        return false
    }

    const roleId = resolveProjectRoleId(project)
    if (!roleId) {
        return false
    }

    if (project.billingEnabled && !options.ignoreIsActive) {
        return isPermissionActive(permissionRolesSettings) && Boolean(permissionRolesSettings.access[roleId])
    }
    return Boolean(permissionRolesSettings.access[roleId])
}

export function hasLorealCluster(projectId: string) {
    const project = store.getters.projectById(projectId)
    
    if (!project) {
        return false
    }
    
    // Проверяем наличие кластера 'loreal' в данных проекта
    return project.clusters && project.clusters.includes('loreal')
}
export function checkModuleIsActive(projectId: string, permissionId: string) {
    const project = store.getters.projectById(projectId)
    if (!project?.rolesSettings) {
        return false
    }
    const rolesSettings = project.rolesSettings
    const permissionRolesSettings = rolesSettings[permissionId]
    if (!permissionRolesSettings) {
        throw new Error(`permission ${permissionId} doesn't exist `)
    }
    if (project.billingEnabled) {
        return isPermissionActive(permissionRolesSettings)
    }
    return true
}